import { createRef } from 'react';
import * as React from 'react';
import { Icon, Button } from '@hotjar/hotsauce';
import type { ButtonProps, IconName } from '@hotjar/hotsauce';
import type { SerializedStyles } from '@emotion/react';
/* eslint-disable jsx-a11y/click-events-have-key-events */

import {
  containerStyles,
  iconWrapperStyles,
  buttonStyles,
  googleButtonStyles,
  googleIconWrapperStyles,
  samlSsoButtonStyles,
  samlSsoIconWrapperStyles,
} from './styles';

export type SSOButtonProps<T extends 'a' | 'button'> = Omit<ButtonProps<T>, 'ref'> & {
  icon: IconName;
  onClick: (e: React.SyntheticEvent) => void;
  iconWrapperStyleProps?: SerializedStyles | SerializedStyles[];
  styleProps?: SerializedStyles | SerializedStyles[];
  containerStyleProps?: SerializedStyles | SerializedStyles[];
};

export const SSOButton = ({
  children,
  icon,
  id,
  onClick,
  iconWrapperStyleProps,
  styleProps,
  containerStyleProps,
  ...otherProps
}: SSOButtonProps<'button'>): JSX.Element => {
  const styles = [buttonStyles, styleProps];
  const iconStyles = [iconWrapperStyles, iconWrapperStyleProps];
  const wrapperStyles = [containerStyles, containerStyleProps];
  const btnRef = createRef<HTMLButtonElement>();

  const iconClickHandler = (e: React.SyntheticEvent) => {
    onClick(e);
    btnRef.current?.focus();
  };
  return (
    <div css={wrapperStyles}>
      <div css={iconStyles} onClick={iconClickHandler} role="presentation">
        <Icon icon={icon} size="l" />
      </div>
      <Button css={styles} ref={btnRef} id={id} size="l" onClick={onClick} {...otherProps}>
        {children}
      </Button>
    </div>
  );
};

type SSOButtonWithHardcodedIconProps = Omit<SSOButtonProps<'button'>, 'icon'>;

export const GoogleSSOButton = (props: SSOButtonWithHardcodedIconProps): JSX.Element => (
  <SSOButton
    styleProps={googleButtonStyles}
    iconWrapperStyleProps={googleIconWrapperStyles}
    {...props}
    icon="google"
  />
);

export const SamlSSOButton = (props: SSOButtonWithHardcodedIconProps): JSX.Element => (
  <SSOButton
    styleProps={samlSsoButtonStyles}
    iconWrapperStyleProps={samlSsoIconWrapperStyles}
    {...props}
    icon="lock"
  />
);

SSOButton.displayName = 'SSOButton';
